<template>
  <div
    class="base-template"
    :class="{'hide-base-bg-image': !isShowBaseContents, 'is_top': isTop}"
  >
    <CommonHeader
      v-if="isShowBaseContents"
      :availablePoint="availablePoint"
      :currentUser="currentUser"
      :isTop="isTop"
      @handleShopNameClick="goToTop"
      @handlePointBoxClick="goToBuyPoint"
    />
    <div class="contents" :class="{adjust: currentUser}">
      <slot></slot>
    </div>
    <CommonFooter
      class="common-footer"
      v-if="isShowBaseContents"
      :currentUser="currentUser"
    />
    <CommonOverlay class="overlay" v-show="isLoading">
      <v-progress-circular
        indeterminate
        color="red"
      ></v-progress-circular>
    </CommonOverlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonHeader from '@/components/organisms/CommonHeader.vue';
import CommonFooter from '@/components/organisms/CommonFooter.vue';

export default {
  name: 'BaseTempalte',

  components: {
    CommonOverlay,
    CommonHeader,
    CommonFooter,
  },

  props: {
    isShowBaseContents: {
      type: Boolean,
      default: true,
    },
    isTop: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      isLoading: 'isLoading',
    }),
    availablePoint() {
      if (this.currentUser) {
        return separateCharacterNumber(this.currentUser.point);
      }
      return '0';
    },
  },

  methods: {
    goToTop() {
      if (this.$route.name === 'Top') {
        return;
      }
      this.$router.push('/');
    },
    goToBuyPoint() {
      if (this.$route.name === 'BuyPoint') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      let url = '/buy-point';
      if (this.$route.params.productId) {
        url += `/${this.$route.params.productId}`;
      }
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss" scoped>
$headerHeight: 70px;
$footerHeight: 80px;

.base-template{
  height: 100%;
  //background-color: #eaddbd;
  background-color: #fff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  &.hide-base-bg-image{
    height: 100%;
    background: $black;
    .contents{
      &.adjust{
        height: 100%;
      }
    }
  }
  .contents{
    width: 100%;
    min-height: calc(100vh - 303px);
    // height: 100vh;
    &.adjust{
      // height: calc(100% - 220px);
      padding-top: 20px;
      padding-bottom: 50px;
      // min-height: 100vh;
      //padding-bottom: 80px;
    }
  }
  .overlay{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.is_top {
  height: auto;
  .contents{
    width: 100%;
    height: auto;
    &.adjust{
      height: calc(100% - 800px);
      min-height: 60vh;
      //padding-bottom: 80px;
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .base-template{
    .contents{
      &.adjust{
        height: auto;
        padding-top: 0px;
      padding-bottom: 20px;
      }
    }
  }
}
</style>
